import { useDestinationsContext } from '@components/OrderWizard/Contexts/DestinationsContext'
import { useOrderContainersContext } from '@components/OrderWizard/Contexts/OrderContainersContext'
import { useWizardMaster } from '@components/OrderWizard/Contexts/WizardMasterContext'
import { StoreDetailProducts } from '@components/StoreMonitoring/StoreDetailsPage/StoreDetailProducts'
import React from 'react'

export const TankProductDetails = ({
  store,
  disabled,
  setOrderEdited,
  addProductToContainer,
  getImpactedTankVolumes,
  setOrderDestinations,
  firstStoreNumber,
  rundownToggled,
}) => {
  if (!store.tanks) return null
  const { currentEntryMode } = useWizardMaster()
  const { productGroupsApi } = useOrderContainersContext()
  const { selectedManifold, setSelectedManifold, selectedTank, setSelectedTank } = useDestinationsContext()
  const addFunction = (tank) => {
    setOrderEdited(true)
    if (currentEntryMode === 'by_product') {
      productGroupsApi.addProductGroup({
        tank,
        store_number: store.store_number,
      })
    } else {
      addProductToContainer(
        tank,
        store.store_number,
        store.market,
        getImpactedTankVolumes,
        setOrderDestinations,
        firstStoreNumber
      )
    }
  }

  return (
    <StoreDetailProducts
      rundownToggled={rundownToggled}
      selectedManifold={selectedManifold}
      setSelectedManifold={setSelectedManifold}
      store={store}
      selectedTank={selectedTank}
      setSelectedTank={setSelectedTank}
      addFunction={addFunction}
      disabled={disabled}
      visibleTankIds={store.grouped_tanks.flatMap((group) => group.tanks.map((tank) => tank.tank_id))}
      currentEntryMode={currentEntryMode}
      productGroupsApi={productGroupsApi}
    />
  )
}
